export const FETCH_OCPP_ERROR = 'FETCH_OCPP_ERROR';
export const FETCH_OCPP_ERROR_SUCCESS = 'FETCH_OCPP_ERROR_SUCCESS';
export const FETCH_OCPP_ERROR_FAIL = 'FETCH_OCPP_ERROR_FAIL';
